module.exports = __webpack_public_path__ + "img/prize-pc.484bcbb0.jpg";